// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"6f734204","202":"9b27adf6","233":"148a7650","305":"1005bfa9","367":"4bc6519f","420":"f3a27dde","458":"773ecb13","492":"b4b2a603","558":"0fb67ec4","629":"dfc83fc7","756":"121497f5","807":"e4e4f54a","821":"329d58bb","972":"886d5551"}[chunkId] + ".chunk.js";
};